import { toast } from 'react-toastify'
import { errorStringify } from '../utils/error'
import { removeAllBindings } from '../workbook'
import { resetComments } from '../slice/commentSlice'
import { resetReferences } from '../slice/referenceSlice'
import { useAppDispatch } from '../dispatch'
import { useEffect, useRef } from 'react'
import mittEmitter from '../utils/mitt'

const useDeleteAllReferences = (
  dispatch: ReturnType<typeof useAppDispatch>
) => {
  const dispatchRef = useRef(dispatch)

  useEffect(() => {
    const handler = () => {
      dispatchRef
        .current(resetReferences())
        .then(() => dispatchRef.current(resetComments()))
        .then(async () => {
          const result = await removeAllBindings()
          if (result.isErr()) {
            throw result.error
          }
          toast.success('🔗All links removed successfully.')
        })
        .catch((err) => {
          toast.error(`removeAllBindings, error: ${errorStringify(err)}`)
          console.error(errorStringify(err))
        })
    }

    mittEmitter.on('DELETE_ALL_REFERENCES', handler)

    return () => {
      mittEmitter.off('DELETE_ALL_REFERENCES', handler)
    }
  }, [])
}

export default useDeleteAllReferences
